import { render, staticRenderFns } from "./WarehouseView.vue?vue&type=template&id=12403660&scoped=true"
import script from "./WarehouseView.vue?vue&type=script&lang=js"
export * from "./WarehouseView.vue?vue&type=script&lang=js"
import style0 from "./WarehouseView.vue?vue&type=style&index=0&id=12403660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12403660",
  null
  
)

export default component.exports